// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"656113fb","455":"ecdc870b","977":"3c331103"}[chunkId] + ".chunk.js";
};